export const shortAdrress = (str) => {
    try {
        return str.length > 29 ? str.substring(0, 29) + "..." : str;    
    } catch (e) {}
}
export const shortContractAdrress = (str) => {
    try {
        return str.length > 12 ? str.substring(str.length- 4) + "" : str;    
    } catch (e) {}
}